module.exports = __webpack_public_path__ + "assets/img/vipBg.31b3bfb2.png";